import React, { useState } from "react";
import { inpS, sp } from "../../constants/styles";

// Shared labelled input. For password fields we render an eye-toggle
// button that flips the rendered input type between "password" and
// "text" — lets the user verify what they typed without leaving the
// form. Living on the shared component means every password field
// across login / signup / forgot-password gets the toggle uniformly.
const Fld = ({ l, v, set, h, type, ph }) => {
  const isPwd = type === "password";
  const [show, setShow] = useState(false);
  const renderedType = isPwd ? (show ? "text" : "password") : (type || "text");

  // Reserve room on the right side of password inputs so the eye
  // button never overlaps the typed text. The base inpS already has
  // marginBottom — we keep it on the wrapper so spacing matches every
  // other field.
  const baseStyle = inpS(h);
  const inputStyle = isPwd
    ? { ...baseStyle, paddingRight: 44, marginBottom: 0 }
    : baseStyle;

  return <>
    <label style={{ color: h.ts || h.sc, fontSize: 12, fontWeight: 600, display: "block", marginBottom: sp.xs + 1, letterSpacing: "0.3px", textTransform: "uppercase" }}>{l}</label>
    {isPwd ? (
      <div style={{ position: "relative", marginBottom: baseStyle.marginBottom }}>
        <input
          value={v}
          onChange={e => set(e.target.value)}
          type={renderedType}
          placeholder={ph || ""}
          style={inputStyle}
          autoComplete={show ? "off" : "current-password"}
        />
        <button
          type="button"
          onClick={() => setShow(s => !s)}
          aria-label={show ? "Hide password" : "Show password"}
          aria-pressed={show}
          title={show ? "Hide password" : "Show password"}
          style={{
            position: "absolute",
            right: 6,
            top: "50%",
            transform: "translateY(-50%)",
            background: "transparent",
            border: "none",
            padding: "6px 8px",
            cursor: "pointer",
            color: h.ts || h.sc,
            fontSize: 16,
            lineHeight: 1,
            borderRadius: 8,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <span aria-hidden="true">{show ? "🙈" : "👁"}</span>
        </button>
      </div>
    ) : (
      <input value={v} onChange={e => set(e.target.value)} type={renderedType} placeholder={ph || ""} style={baseStyle} />
    )}
  </>;
};

export default Fld;
